import constants from 'utils/constants';
import AuthService from './authService';
import * as API from './api';

export const addToLocalStorage = (
  key,
  value,
  expirationTime = 10 * 60 * 1000,
) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + expirationTime,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getFromLocalStorage = (key, time = 10 * 60 * 1000) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  updateExpirationTime(key, item.value, time);
  return item.value;
};

export const updateExpirationTime = (key, value, time = 10 * 60 * 1000) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + time,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const isUserAuthenticated = () => {
  return AuthService.hasValidTokens();
};

export const logOut = () => {
  API.post('/v1/logout/', null, {
    withCredentials: true,
    skipAuthRetry: true,
  }).catch(() => {});
  AuthService.clearTokens();
  localStorage.removeItem('username');
  localStorage.removeItem(
    constants.advancedSearchPageLastSearchLocalStorageKey,
  );
  localStorage.removeItem(constants.filmPageCollapsibleSectionsLocalStorageKey);
  localStorage.removeItem(
    constants.dataAuditPageCollapsibleSectionsLocalStorageKey,
  );
};

export const removeFromLocalStorage = (key) => localStorage.removeItem(key);
